// extracted by mini-css-extract-plugin
module.exports = {"root":"Layout-module_root_2rCZz"};